module.exports = __webpack_public_path__ + "img/img7.77b07ab2.jpg";